/**
 * @generated SignedSource<<84e667bc2b0baa9be8aa16e2ebd00769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_sponsoredItems$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMergedSponsoredAndYmalItems_sponsoredItems">;
  readonly " $fragmentType": "PdpRespSimilarItemsLanding_sponsoredItems";
};
export type PdpRespSimilarItemsLanding_sponsoredItems$key = {
  readonly " $data"?: PdpRespSimilarItemsLanding_sponsoredItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_sponsoredItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsLanding_sponsoredItems",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMergedSponsoredAndYmalItems_sponsoredItems"
    }
  ],
  "type": "SponsoredItems",
  "abstractKey": null
};

(node as any).hash = "ddae22236ddbe04db37f59d4eddd4696";

export default node;
